export const FETCH_TECHNICIAN_LOG = '@@material/fetch-technician-log';
export const FETCH_TECHNICIAN_LOG_SUCCESS = '@@material/fetch-technician-log-success';
export const FETCH_TECHNICIAN_LOG_FAILURE = '@@material/fetch-technician-log-failure';
